import { ProgramEntity } from '@/modules/programs/domain/entities/ProgramEntity';
import { Program, Role, RoleTypes } from '@/types';

export class RoleEntity {
  UUID: string;
  name: string;
  description: string;
  avatarURL: string;
  type: RoleTypes;
  kind?: string;
  programs?: Program[];
  order: number;

  constructor(role: Role) {
    this.UUID = role.UUID;
    this.name = role.name;
    this.description = role.description;
    this.avatarURL = role.avatarURL;
    this.type = role.type;
    this.kind = role.kind;
    this.programs = (role.programs || []).map((program) => new ProgramEntity(program));
    this.order = role.order;
  }
}
